import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50 text-lg font-bold">
                漫
              </span>
              <span className="font-heading text-xl text-background-50">178漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-background-200">
              漫友同好聚集地，按作品和题材划分漫圈。随时找到同好交流剧情、分享心得，追漫有人陪聊。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-community-line", "ri-chat-3-line", "ri-vip-crown-2-line", "ri-star-smile-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#"
                    aria-label="社区账号"
                    onClick={(e) => e.preventDefault()}
                    className="grid h-9 w-9 place-items-center rounded-full bg-background-100/10 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors"
                  >
                    <i className={`${icon} text-lg`} />
                  </a>
                ),
              )}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li><Link to="/" className="hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/works" className="hover:text-background-50 transition-colors">漫画作品</Link></li>
              <li><Link to="/circles" className="hover:text-background-50 transition-colors">漫圈社区</Link></li>
              <li><Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">热门漫圈</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li>热血追番组</li>
              <li>悬疑推理圈</li>
              <li>恋爱轻语社</li>
              <li>国漫新势力</li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-300" />
                <span>hello@178manhua.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-question-line text-primary-300" />
                <Link to="/about" className="hover:text-background-50 transition-colors">常见问题</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-100/10 pt-6 text-xs text-background-300">
          <p>© 2026 178漫画网 · 漫友同好交流聚集地 · 仅供同好交流分享</p>
          <p>按作品和题材划分漫圈 · 追漫有人陪聊</p>
        </div>
      </div>
    </footer>
  );
}